import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a0fd5576&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a0fd5576&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fd5576",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0fd5576')) {
      api.createRecord('a0fd5576', component.options)
    } else {
      api.reload('a0fd5576', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a0fd5576&scoped=true", function () {
      api.rerender('a0fd5576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/search/index.vue"
export default component.exports